import React from 'react'
import { Card } from 'react-bootstrap'

import useAppSelector from '../../hooks/useAppSelector'
import useCurrentCompanyOrFail from '../../hooks/useCurrentCompanyOrFail'
import { useCurrentUserOrFail } from '../../hooks/useCurrentUserOrFail'
import companyService from '../../lib/services/companyService'
import {
  selectEmailContentType,
  selectEmailService,
} from '../../redux/slices/session'

/**
 * ⚠️⚠️⚠️ If making changes in here, you should also make changes
 * in the invite-referral-partner.html.twig email template in the RQ-API project
 */
const InviteReferralPartnerEmailPreview: React.FC = () => {
  const currentUser = useCurrentUserOrFail()
  const currentCompany = useCurrentCompanyOrFail()

  const emailContentType = useAppSelector(selectEmailContentType)
  const emailServiceType = useAppSelector(selectEmailService)
  const isPersonnalOrCompany =
    emailServiceType === 'NYLAS' &&
    (emailContentType === 'PERSONAL' || emailContentType === 'COMPANY')

  const inviteLink = companyService.getInvitationLink(
    currentCompany.referralCode,
  )

  return (
    <div className="pt-3" style={{ lineHeight: 1.75 }}>
      <Card className="p-5 m-0 box-shadow-lg">
        <p>Hi,</p>

        {isPersonnalOrCompany && (
          <p>
            I'd like to invite you to join me on RQ — the professional referral
            platform.
          </p>
        )}
        {!isPersonnalOrCompany && (
          <p>
            {currentUser.fullName} from {currentCompany.presentationName} has
            invited you to join them on RQ — the professional referral platform.
          </p>
        )}

        <p>
          You can claim your free account here:{' '}
          <a href={inviteLink} target="_blank" rel="noreferrer">
            {inviteLink}
          </a>
        </p>

        <div style={{ textAlign: 'center', marginBottom: '2em' }}>
          <a
            href={inviteLink}
            target="_blank"
            rel="noreferrer"
            className="btn btn-primary"
          >
            Accept invite
          </a>
        </div>

        <p style={{ marginBottom: 0 }}>
          With RQ, {isPersonnalOrCompany ? 'we' : 'you'} can:
        </p>

        <ul style={{ marginTop: 0 }}>
          <li>Refer clients securely and compliantly</li>
          <li>Track every case in real time</li>
          <li>Strengthen professional relationships</li>
          <li>Unlock new revenue from referrals</li>
        </ul>

        <p>
          It’s quick to join, easy to use, and built for you to collaborate more
          closely on shared clients.
        </p>

        <p>
          You can learn more about RQ on its website:{' '}
          <a href="https://www.rq.app/" title="Learn more about RQ">
            https://www.rq.app
          </a>
          .
        </p>

        <p>
          Best wishes,
          <br />
          <strong>The RQ Team</strong>
        </p>
      </Card>
    </div>
  )
}

export default InviteReferralPartnerEmailPreview
